import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { useQuery } from "@apollo/react-hooks";
import $ from "jquery";
import { Redirect } from "react-router-dom";
import { setPlayingAction } from "../store/actions/pageActions";
import VideoList from "../components/VideoList";
import { GET_TUTORIAL_VIDEO } from "./../lib/graphqlQueries";
import logo from "../assets/white-logo.svg";
import { isLoggedIn, deleteUser, getUserInfo } from "./../lib/session";

const Library = ({ currentlyPlaying, dispatch, history, track }) => {
  const { userDetails: { activity = [] } = {} } = getUserInfo("data") || {};
  const numLogins =
    activity &&
    activity.map(obj => obj && obj.action === "login").filter(n => n).length;

  const logout = () => {
    const logoutFunc = () => {
      deleteUser();
      history.push("/");
    };
    track("logout", "system-logout", logoutFunc, logoutFunc);
  };

  const resize = () => {
    setWinWidth($(window).width() - 10);
  };

  const variables = { type: "medical" };
  const [winWidth, setWinWidth] = useState(0);
  const { data, error, loading } = useQuery(GET_TUTORIAL_VIDEO, {
    variables,
    errorPolicy: "all"
  });

  useEffect(() => {
    resize();
    window.addEventListener("resize", resize);
    $("html, body")
      .stop()
      .animate({ scrollTop: 0 }, 500);
    return () => {
      window.removeEventListener("resize", resize);
    };
  }, []);

  if (loading) {
    return <p>Loading...</p>;
  }
  if (error) {
    if (isLoggedIn()) {
      logout();
    } else {
      return <p>Error getting data: Please reload your page.</p>;
    }
  }

  const { categoryList: { nodes: categories = [] } = {} } = data || {};

  let tutorialVideo = {};
  if (categories.length > 0) {
    const { videos: { nodes: tutorials = [] } = {} } = categories[0] || {};
    tutorialVideo = tutorials.length > 0 ? tutorials[0] : "";
  }
  const { videoId: tutorialId } = tutorialVideo || {};

  const firstTimeVisitor =
    numLogins === 1 && tutorialId && !getUserInfo("loaded");

  return (
    <>
      {firstTimeVisitor && <Redirect to={`/videos/${tutorialId}`} />}
      {!firstTimeVisitor && (
        <div>
          <section id="header">
            <img className="header-logo" src={logo} width="90" height="90" />
          </section>
          <VideoList
            section="medical"
            winWidth={winWidth}
            playVideo={id => id !== "" && dispatch(setPlayingAction(id))}
            operation="redirect"
            currentlyPlaying={currentlyPlaying}
            track={track}
          />
        </div>
      )}
    </>
  );
};

const mapStateToProps = state => ({
  currentlyPlaying: state.pageReducers.currentlyPlaying
});

export default connect(mapStateToProps)(Library);
